<template>
    <div class="container root">
        <div class="stripe top animate animate-go"></div>
        <img src="image-small.png"
             srcset="https://www.ideal-versicherung.de/idam/media/Produktbilder/IUL/Landing%20Pages/Basisinformationen/basisinformation_header_sm.png 320w,
                     https://www.ideal-versicherung.de/idam/media/Produktbilder/IUL/Landing%20Pages/Basisinformationen/basisinformation_header_md.png 800w,
                     https://www.ideal-versicherung.de/idam/media/Produktbilder/IUL/Landing%20Pages/Basisinformationen/basisinformation_header_lg.png 1200w"
             alt="Image description">
        <div class="claim-container">
            <h1 v-html="title"></h1>
            <h2 class="subtitle" id="subtitle" v-html="sub"></h2>
        </div>
        <div class="stripe bottom animate animate-go">
            <ul class="nav main-nav">
               <li v-for="(item,idx) in menu">
                   <a :href="item.link_url" :key="idx"><span>{{item.link_text}}</span></a>
               </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';


    export default {
        name: 'StageMod',
        computed: {
            ...mapGetters([
                'menu'
            ])
        },
        data() {
            return {
                title: window.header.title,
                sub: window.header.sub
            }
        },

        mounted() {
        }
    }
</script>
<style scoped lang="scss">


    #bg-stage {
        position: relative;
        top: 0;
        left:0;
        z-index:0;
    }

    .stripe.bottom {
        width:auto;
    }


    .container  picture img {
        width:100%;
        left:0;
    }

    .nav.main-nav li {
        min-width: auto;
        margin-left:1em;
        margin-right:1em;
    }

</style>
